export const FIXED_CATALOG_ITEM_HEADER_DEFAULT_HEIGHT = 72;
export const CONTENT_MAX_WIDTH_DESKTOP = 850;
